module.exports = __webpack_public_path__ + "static/img/timg.63b9109.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timg.jpeg
// module id = 15UH
// module chunks = 2